// Navigation.js
import { useSelector } from 'react-redux';
import { useMenuItems } from 'menu-items';
import { Box, Typography, CircularProgress } from '@mui/material';
import NavGroup from './NavGroup';

const Navigation = () => {
  const menu = useSelector((state) => state.menu);
  const { drawerOpen } = menu;
  const { menuItems, loading, error } = useMenuItems();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    console.error('Menu loading error:', error);
  }

  return (
    <Box sx={{ pt: drawerOpen ? 2 : 0, '& > ul:first-of-type': { mt: 0 } }}>
      {menuItems.items.map((item) => {
        if (!item?.id) return null;

        return item.type === 'group' ? (
          <NavGroup key={item.id} item={item} />
        ) : (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Invalid Menu Item Type
          </Typography>
        );
      })}
    </Box>
  );
};

export default Navigation;
